import { render, staticRenderFns } from "./PaseListaSection.vue?vue&type=template&id=40687574&scoped=true"
import script from "./PaseListaSection.vue?vue&type=script&lang=js"
export * from "./PaseListaSection.vue?vue&type=script&lang=js"
import style0 from "./PaseListaSection.vue?vue&type=style&index=0&id=40687574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40687574",
  null
  
)

export default component.exports